module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "poll-choice"
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "20px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ((_vm.idx + 1) + ".")
    }
  }, [_c('el-input', {
    attrs: {
      "label": "Choice",
      "placeholder": "Choice",
      "debounce": "500",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.choice.choice),
      callback: function($$v) {
        _vm.$set(_vm.choice, "choice", $$v)
      },
      expression: "choice.choice"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Matches",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "comma", undefined, $event.key, undefined) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        $event.preventDefault();
        return _vm.addTag($event)
      }
    },
    model: {
      value: (_vm.newTag),
      callback: function($$v) {
        _vm.newTag = $$v
      },
      expression: "newTag"
    }
  }, [_c('template', {
    slot: "suffix"
  }, [_c('div', {
    staticClass: "poll-tags"
  }, _vm._l((_vm.choice.matches), function(tag) {
    return _c('el-tag', {
      key: tag,
      staticClass: "poll-tag",
      attrs: {
        "size": "mini",
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleCloseTag(tag)
        }
      }
    }, [_vm._v("\n              " + _vm._s(tag) + "\n            ")])
  }), 1)])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "fa fa-trash",
      "type": "danger",
      "plain": "",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleDeleteChoice
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27e908c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/polls/PollChoiceInput.vue
// module id = 3188
// module chunks = 3